import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import UtilityBar from "./components/UtilityBar";
import PrimaryNav from "./components/PrimaryNav";
import MobileNav from "./components/MobileNav";
import LogoutConfirmation from "../../containers/Header/ProfileItem/LogoutConfirmation";
import useAccountSession from "./useAccountSession";
import "./styles.css";

const SiteHeader = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { confirmingLogout, requestLogout, cancelLogout, performLogout } =
    useAccountSession();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header className="sy-site-header">
      <UtilityBar />
      <PrimaryNav
        menuOpen={menuOpen}
        onMenuToggle={() => setMenuOpen((prev) => !prev)}
        onLogout={requestLogout}
      />
      <MobileNav
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onLogout={requestLogout}
      />
      {confirmingLogout && (
        <LogoutConfirmation onClose={cancelLogout} onLoggedOut={performLogout} />
      )}
    </header>
  );
};

export default SiteHeader;
